export default __webpack_public_path__ + "static/media/gallery-img-6.fed9f691.jpg";